<div class="m-block">
  <div class="m-block__header">
    <span class="m-block__contentTitle">
      {{ title() }}
      @if (isOptional()) {
        <span class="m-block__optionalLabel">{{ 'COMMON.OPTIONAL' | translate }}</span>
      }
    </span>
    <button type="button" class="m-block__addSectionBtn" (click)="onSectionAdd.emit($event)">
      {{ addSectionLabel()}}
    </button>
  </div>
  <div class="m-block__content">
    <ng-content />
  </div>
</div>
